var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"slide"}},[_c('div',{staticClass:"tweet-text"},[_c('div',{staticClass:"user"},[_c('div',{staticClass:"user-icon",style:({
        backgroundImage: ("url(" + _vm.userIconSrc + ")")
      })}),_vm._v(" "),_c('div',{staticClass:"user-name"},[_vm._v(_vm._s(_vm.userName))])]),_vm._v(" "),_c('div',{staticClass:"text"},[_vm._v(_vm._s(_vm.displayText))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dc14f382","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/TweetText.vue
// module id = null
// module chunks = 